import { useRecoilState, useSetRecoilState, translationDataState, tourConfigsState } from '../../../store';
import { useEffect, useState } from 'react';

interface ISetDataToRecoil {
  translation: any;
  rtl: boolean;
}

const SetDataToRecoil = (props: ISetDataToRecoil) => {
  const { translation, rtl } = props;
  const [inited, setInited] = useState(false);
  const setTranslation = useSetRecoilState(translationDataState);
  const [tourConfigs, setTourConfigs] = useRecoilState(tourConfigsState);

  useEffect(() => {
    if (!inited) {
      if (translation && Object.keys(translation).length > 0) {
        setTranslation(translation);
        setTourConfigs({ ...tourConfigs, rtl });
        setInited(true);
      }
    }
  }, [translation]);
  return null;
};

export default SetDataToRecoil;
